import { useGetIdentity, useGetOne } from "ra-core";

import type { Sale } from "@/components/atomic-crm/types";

/** true si el usuario actual es administrador (sales.administrator). */
export const useEsAdmin = (): boolean => {
  const { identity } = useGetIdentity();
  const { data } = useGetOne<Sale>(
    "sales",
    { id: identity?.id as number },
    { enabled: !!identity?.id, staleTime: 5 * 60 * 1000 },
  );
  return data?.administrator === true;
};
